<template>
  <div>
    <v-snackbar top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>

    <v-card class="d-flex flex-column">
      <v-card-title class="grid-close">
        <span class="headline">Configurar pantalla</span>
        <v-btn
          style="right: 10px; top: 10px"
          icon
          color="primary"
          fab
          absolute
          @click="$emit('cancel')"
          v-if="!loading"
        >
          <v-icon dark>fa-times</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="screen.name"
                label="Nombre de la pantalla"
                rounded
                filled
                :loading="loading"
                clearable
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="screen.description"
                label="Descripción"
                rounded
                filled
                :loading="loading"
                clearable
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <v-select
                :items="playlists"
                item-text="name"
                rounded
                filled
                item-value="id"
                :loading="loading"
                v-model="screen.defaultPlaylist"
                label="Lista de reproducción por defecto"
                persistent-hint
                hint="El contenido de esta lista se mostrara los días que no se hayan calendarizado."
              ></v-select>
            </v-col>

            <v-col cols="12" sm="12" md="12" v-if="screen.playlist">
              <p class="current-playlist">
                Actualmente se está reproduciendo la lista <span style="cursor:pointer" @click="showCurrentPlaylist" title="Clic para ver" class="font-weight-bold">{{ currentPlaylistName }}</span>
               
              </p>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              class="mt-5"
              cols="12"
              sm="12"
              md="12"
            >
              <v-btn rounded filled color="btn-color" @click="newScheduler">
                <v-icon left> fas fa-plus </v-icon>
                Agregar calendarización
              </v-btn>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <p
                style="text-align: center"
                class="ml-5"
                v-if="!scheduler.length"
              >
                Sin listas de reproducción calendarizadas. 🙁
              </p>

              <v-data-table
                v-else
                :headers="headers"
                :items="scheduler"
                item-key="name"
                sort-by="start"
                class="elevation-1"
              >
                <template v-slot:[`item.name`]="{ item }">
                  <p class="playlist-name">{{ item.name }}</p>
                </template>
                <template v-slot:[`item.options`]="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="mx-1"
                        fab
                        v-on="on"
                        @click="showPlaylist(item)"
                        dark
                        x-small
                        :elevation="0"
                        color="rgba(0, 0, 0, 0.6)"
                      >
                        <v-icon dark>fa-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>Ver</span>
                  </v-tooltip>

                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="mx-1"
                        fab
                        v-on="on"
                        @click="showDeleteDialog(item, index)"
                        dark
                        x-small
                        :elevation="0"
                        color="rgba(0, 0, 0, 0.6)"
                      >
                        <v-icon dark>fa-trash</v-icon>
                      </v-btn>
                    </template>
                    <span>Eliminar</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <v-row class="pa-0 ma-0">
            <v-col cols="12" sm="12" md="12">
              <v-row justify="end">
                <v-btn
                  :loading="loading"
                  @click="originalScreen ? updateScreen() : addScreen()"
                  style="z-index: 999"
                  class="save-btn"
                  color="btn-color"
                  >Guardar</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-dialog
      v-if="addSchedulerDialog"
      persistent
      v-model="addSchedulerDialog"
      max-width="600px"
    >
      <add-scheduler
        :playlists="playlists"
        @success="verifyScheduler"
        :selectedPlaylist="selectedPlaylist"
        @cancel="addSchedulerDialog = false"
      />
    </v-dialog>

    <v-dialog
      fullscreen
      hide-overlay
      v-if="viewPlaylistDialog"
      v-model="viewPlaylistDialog"
    >
      <view-playlist
        :name="selectedPlaylist.name"
        :files="selectedPlaylist.files"
        @cancel="viewPlaylistDialog = false"
      />
    </v-dialog>

    <v-dialog max-width="500px" v-if="deleteDialog" v-model="deleteDialog">
      <remove
        ref="deleteComponent"
        :name="selectedPlaylist.name"
        @success="confirmDelete"
        @cancel="deleteDialog = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import { db, fb } from "@/firebase";
import { mapActions, mapState } from "vuex";
import addScheduler from "@/components/add-scheduler";
import viewPlaylist from "../Playlists/view-playlist";
import remove from "@/components/delete";
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");

export default {
  name: "new-screen",
  props: [
    "originalScreen",
    "code",
    "result",
    "new",
    "selectedCountry",
    "selectedCity",
    "selectedAgency",
    "selectedApp",
  ],
  components: {
    addScheduler,
    viewPlaylist,
    remove,
  },
  data() {
    return {
      snackbarText: "",
      snackbar: false,
      loading: true,
      playlists: [],
      screen: {
        name: "",
        description: "",
      },
      scheduler: [],
      viewPlaylistDialog: false,
      addSchedulerDialog: false,
      selectedPlaylist: null,
      deleteDialog: false,
      index: null,
      headers: [
        {
          text: "Playlist",
          value: "name",
          width: "100px",
        },
        {
          text: "Fecha inicial",
          value: "start",
          width: "120px",
        },
        {
          text: "Fecha final",
          value: "end",
          width: "120px",
        },
        {
          text: "Archivos",
          value: "filesCount",
        },
        {
          value: "options",
          sortable: false,
          align: "end",
          width: "120px",
        },
      ],
    };
  },
  computed: {
    ...mapState(["user", "groupId"]),
    currentPlaylistName() {
      let playlistResult = this.playlists.find(
        (item) => item.id == this.screen.playlist
      );
      return playlistResult ? playlistResult.name : "";
    },
  },

  methods: {
    showPlaylist(playlist) {
      this.selectedPlaylist = playlist;
      this.viewPlaylistDialog = true;
    },
    showCurrentPlaylist() {
      let playlistResult = this.playlists.find(
        (item) => item.id == this.screen.playlist
      );
      this.selectedPlaylist = playlistResult;
      this.viewPlaylistDialog = true;
    },
    actualPlaylist() {
      return new Promise((resolve, reject) => {
        let today = parseInt(
          moment()
            .tz("America/tegucigalpa")
            .format()
            .substr(0, 10)
            .replace(/-/g, "")
        );

        for (let i = 0; i < this.scheduler.length; i++) {
          const currentSchedule = this.scheduler[i];
          let startDate = parseInt(currentSchedule.start.replaceAll("-", ""));
          let endDate = parseInt(currentSchedule.end.replaceAll("-", ""));

          if (
            startDate <= today &&
            endDate >= today &&
            currentSchedule.playlist
          ) {
            // console.log("Calendarizacion encontrada");
            return resolve(currentSchedule.playlist);
          }
        }

        // console.log('No hay calendarizacion');
        return resolve(this.screen.defaultPlaylist);
      });
    },
    showDeleteDialog(playlist, index) {
      this.index = index;
      this.selectedPlaylist = playlist;
      this.deleteDialog = true;
    },
    confirmDelete() {
      this.deleteDialog = false;
      this.scheduler.splice(this.index, 1);
    },
    async updateScreen() {
      let playlist = await this.actualPlaylist();
      // console.log(playlist);
      let schedule = this.scheduler.map((item) => {
        let dateStart = item.start.split("-");
        let dateEnd = item.end.split("-");
        return {
          playlist: item.playlist,
          start: fb.firestore.Timestamp.fromDate(
            new Date(
              parseInt(dateStart[0]),
              parseInt(dateStart[1]) - 1,
              parseInt(dateStart[2]),
              parseInt("00"),
              parseInt("00"),
              parseInt("01")
            )
          ),
          end: fb.firestore.Timestamp.fromDate(
            new Date(
              parseInt(dateEnd[0]),
              parseInt(dateEnd[1]) - 1,
              parseInt(dateEnd[2]),
              parseInt("23"),
              parseInt("59"),
              parseInt("59")
            )
          ),
          active: true,
        };
      });

      if (this.screen.name && this.screen.defaultPlaylist) {
        this.loading = true;
        db.collection("screens")
          .doc(this.originalScreen[".key"])
          .update({
            name: this.screen.name,
            description: this.screen.description ? this.screen.description : "",
            playlist: playlist,
            modifiedAt: new Date(),
            modifiedBy: this.user.uid,
            schedule: schedule.length ? schedule : [],
            defaultPlaylist: this.screen.defaultPlaylist,
            isScheduled: schedule.length ? true : false,
            active: true,
          })
          .then((response) => {
            this.$emit("success");
          })
          .catch((error) => {
            this.loading = false;
            this.snackbarText =
              "Ocurrió un error inesperado, inténtelo nuevamente.";
            this.snackbar = true;
          });
      } else {
        this.snackbarText = "Ingrese todos los campos.";
        this.snackbar = true;
      }
    },

    async addScreen() {
      let playlist = await this.actualPlaylist();
      let schedule = this.scheduler.map((item) => {
        let dateStart = item.start.split("-");
        let dateEnd = item.end.split("-");
        return {
          playlist: item.playlist,
          start: fb.firestore.Timestamp.fromDate(
            new Date(
              parseInt(dateStart[0]),
              parseInt(dateStart[1]) - 1,
              parseInt(dateStart[2]),
              parseInt("00"),
              parseInt("00"),
              parseInt("01")
            )
          ),
          end: fb.firestore.Timestamp.fromDate(
            new Date(
              parseInt(dateEnd[0]),
              parseInt(dateEnd[1]) - 1,
              parseInt(dateEnd[2]),
              parseInt("23"),
              parseInt("59"),
              parseInt("59")
            )
          ),
          active: true,
        };
      });

      if (this.result && this.screen.name && this.screen.defaultPlaylist) {
        this.loading = true;
        db.collection("screens")
          .add({
            name: this.screen.name,
            description: this.screen.description ? this.screen.description : "",
            playlist: playlist,
            createdAt: new Date(),
            createdBy: this.user.uid,
            country: this.selectedCountry,
            city: this.selectedCity,
            agency: this.selectedAgency,
            schedule: schedule.length ? schedule : [],
            isScheduled: schedule.length ? true : false,
            defaultPlaylist: this.screen.defaultPlaylist,
            selectedApp: this.selectedApp,
            active: true,
            uuid: this.result.uuid,
            groupId: this.groupId,
          })
          .then(async (response) => {
            this.loading = false;
            await db.collection("tempScreens").doc(this.result.id).update({
              configured: true,
            });
            this.$emit("success");
          })
          .catch((error) => {
            this.loading = false;
            this.snackbarText =
              "Ocurrió un error inesperado, inténtelo nuevamente.";
            this.snackbar = true;
          });
      } else {
        this.snackbarText = "Ingrese todos los campos.";
        this.snackbar = true;
      }
    },

    verifyScheduler(payload) {
      let eventStart = Number.parseInt(
        payload.start.toString().replaceAll("-", "")
      );

      let eventEnd = Number.parseInt(
        payload.end.toString().replaceAll("-", "")
      );

      let exist = false;

      for (let i = 0; i < this.scheduler.length; i++) {
        const event = this.scheduler[i];

        const start = Number.parseInt(
          event.start.toString().replaceAll("-", "")
        );
        const end = Number.parseInt(event.end.toString().replaceAll("-", ""));

        if (
          (eventStart <= start && eventEnd >= start) ||
          (eventStart >= start && eventEnd <= end) ||
          (eventStart <= end && eventEnd >= end)
        ) {
          this.snackbarText =
            "Solo es permitido asignar una lista de reproducción por dia.";
          this.snackbar = true;
          exist = true;
        }
      }

      if (!exist) {
        this.scheduler.push(payload);
        this.addSchedulerDialog = false;
      }
    },

    newScheduler() {
      this.addSchedulerDialog = true;
    },
  },

  async mounted() {
    let groupId = this.$store.state.groupId;
    this.loading = true;

    await db
      .collection("playlists")
      .where("groupId", "==", groupId)
      .orderBy("name", "asc")
      .get()
      .then((response) => {
        response.forEach((item) => {
          let playlist = item.data();
          playlist.id = item.id;
          this.playlists.push(playlist);
        });
        this.playlists = this.playlists.filter((item) => item.files.length > 0);
        this.loading = false;
      });

    if (this.originalScreen) {
      this.screen = JSON.parse(JSON.stringify(this.originalScreen));

      this.screen.defaultPlaylist = this.screen.defaultPlaylist
        ? this.screen.defaultPlaylist
        : this.screen.playlist;
      this.scheduler =
        this.screen.schedule && this.screen.schedule.length
          ? this.screen.schedule
          : [];

      this.scheduler.forEach((item) => {
        let result = this.playlists.find(
          (playlist) => playlist.id == item.playlist
        );
        item.name = result.name;
        item.files = result.files;
        item.filesCount = result.files.length;
        item.start = moment(new Date(item.start.seconds * 1000)).format(
          "YYYY-MM-DD"
        );
        item.end = moment(new Date(item.end.seconds * 1000)).format(
          "YYYY-MM-DD"
        );
      });
    }
  },
};
</script>

<style scoped>
.list-group {
  display: grid !important;
  grid-template-columns: 33% 33% 33%;
  min-width: 400px;
}
.cards-container {
  background-color: #e1dbf07d;
  border-radius: 20px;
  padding: 20px;
  min-height: 400px;
  overflow-y: auto;
}

.v-card > *:first-child:not(.v-btn):not(.v-chip),
.v-card > .v-card__progress + *:not(.v-btn):not(.v-chip) {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.card {
  background-color: rgb(83, 81, 81);
  padding: 20px;
  border-radius: 10px;
  color: white;
}
.files-count {
  position: absolute;
  right: 20px;
  color: gray;
}

.card-icon {
  font-size: 20px;
}
.playlist-name {
  max-width: 200px;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 10px;
}

.current-playlist {
  /* font-weight: bold; */
  max-width: 100%;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background-color: #eeeeee;
  padding: 10px;
  color: black;
  text-align: center;
}
</style>